site.mMenu = {
	selector: '#mainmenu',
	API: null,
	init: function() {
		site.mMenu.clone();

		var $mMenu = $('#mMenu');

		if ($mMenu.length === 0) {
			$('#mainmenuToggle').remove();
			return false;
		}

		$mMenu.mmenu({
			// Options
			offCanvas: {
				position: 'right'
			},
			extensions: [
				'position-front',
				'position-right'
			],
			navbar: {
				title: '&nbsp;'
			},
			navbars: [{
				position: 'top',
				content: site.mMenu.getNavbarTopContent()
			}],
			keyboardNavigation: {
				enable: true,
				enchance: true
			}
		}, {
			// Configuration
			language: site.mMenu.getLanguage(),
			classNames: {
				selected: 'active'
			},
			offCanvas: {
				menu: {
					insertMethod: 'appendTo'
				}
			}
		});

		$('.mm-page').removeClass('mm-slideout');
		$('.mm-navbar__title').attr('tabindex', '-1');

		site.mMenu.API = $mMenu.data('mmenu');
		var $toggle = $('#mainmenuToggle');

		$toggle.click(function() {
			if (site.mMenu.isOpen()) {
				site.mMenu.close();
			} else {
				site.mMenu.open();
			}
		});

		$('.mm-wrapper__blocker .mm-tabstart').on('click', function(e) {
			site.mMenu.close();
		});

		$(document).keydown(function (e) {
			if (e.which === 27 && site.mMenu.isOpen()) {
				site.mMenu.close();
			}
		});

		$('.mm-tabend').on('focus', function(e) {
			site.mMenu.close();
		});

		site.mMenu.appendSearch();
		site.mMenu.submenuClassFix();
	},

	open: function() {
		var $toggle = $('#mainmenuToggle');
		site.mMenu.API.open();
		$toggle.attr('aria-expanded', true);
		$('*','#contentContainer, #footerInfo').attr('tabindex', -1);
	},

	close: function() {
		var $toggle = $('#mainmenuToggle');
		site.mMenu.API.close();
		$toggle.focus();
		$toggle.removeAttr('aria-expanded');
		$('*', '#contentContainer, #footerInfo').removeAttr('tabindex');
	},

	clone :function() {
		var $mmLevel1 = $('#mainmenu').find('.mmLevel1');
		if ($mmLevel1.length > 0) {
			var $body = $('body'),
				$html = $('<div id="mMenu" role="navigation" aria-label="Farsíma Valmynd"></div>'),
				$mMenu = $mmLevel1.clone().removeAttr('id');
			$('ul', $mMenu).removeAttr('id');
			$html.append($mMenu);
			$body.append($html);
		}
	},

	getLanguage: function() {
		var currentLang = $('html').attr('lang');
		return (currentLang in $.mmenu.i18n()) ? currentLang : 'en';
	},

	isOpen: function() {
		return $('html').hasClass('mm-wrapper_opening');
	},

	getNavbarTopContent: function() {
		return '<a href="#mm-1" class="home"><span class="sr-only">Til baka í aðalvalmynd</span></a>';
	},

	appendQn: function() {
		var $menu = $('.mm-navbar', '#mm-1'),
			$qn = $('.qn').clone();
		$('ul:first-child', $qn).remove();
		$qn.appendTo($menu);
	},

	appendSearch: function() {
		var $html = $('<div id="mSearchBox" role="search"></div>'),
			$mSearchBox = $('#searchForm').clone().removeAttr('id'),
			$menu = $('.mm-navbar', '#mm-1');
		$html.append($mSearchBox);
		$html.appendTo($menu);

		$('[id]', $mSearchBox).each(function() {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm'+$id.substr(0,1).toUpperCase()+$id.substr(1),
				$label = $('label[for="'+$id+'"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);

			if (typeof $this.attr('name') !== typeof undefined) {
				$this.attr('name', $newId);
			}
		});
	},

	submenuClassFix: function() {
		var $html = $('html'),
			$div = $('.mm-panel:first-child', '.mm-panels'),
			observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === 'class') {
					var attributeValue = $(mutation.target).prop(mutation.attributeName);
					if (attributeValue.indexOf('mm-panel_opened-parent') > 0) {
						$html.addClass('mm-subopened');
					}
					else {
						$html.removeClass('mm-subopened');
					}

				}
			});
		});
		observer.observe($div[0], {
			attributes: true
		});

		if ($div.hasClass('mm-panel_opened-parent')) {
			$html.addClass('mm-subopened');
		}
	}
};

site.inits.push('site.mMenu.init()');
